export const commonFeatures = {
  alerts: true,
  folders: true,
  'home/uk': true,
  'home/fr': true,
  referral: true,
  'nav/user': true,
  'footer/fr': true,
  'account/user': true,
  'public-home/fr': true,
  'public-home/uk': true,
  'public-home/demo': true,
  'nav-public-pricing': true,
  'nav-public-customers-story': true,
  'nav-demo': true,
};

/**
 * Take all features and disable all features that are in
 * the array
 *
 * @example
 *
 * getFeaturesWithSomeDisabled(["alerts"]) -> { folders: true, alerts: false }
 */
export const getFeaturesWithSomeDisabled = (
  listOfFeaturesToDisable: Array<keyof typeof commonFeatures>,
) => {
  const featureWithDisabling = { ...commonFeatures };
  listOfFeaturesToDisable.forEach(key => {
    if (!featureWithDisabling.hasOwnProperty(key))
      throw new Error(`[Features]: ${key} is not a feature`);

    featureWithDisabling[key] = false;
  });

  return featureWithDisabling;
};

export const featuresByCountry = {
  fr: getFeaturesWithSomeDisabled(['home/uk', 'public-home/uk']),
  uk: getFeaturesWithSomeDisabled([
    'alerts',
    'home/fr',
    'referral',
    'nav/user',
    'footer/fr',
    'account/user',
    'public-home/fr',
    'public-home/demo',
    'nav-public-pricing',
    'nav-public-customers-story',
    'nav-demo',
  ]),
} as const;
